<template>
    <el-dialog
            class="detail-info-dia"
            title="执照领取信息"
            :visible.sync="isShow"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :width="dw"
            top="12vh"
    >
        <div class="showLicenseAddress">
            <el-form  ref="formData" >
                <el-form-item label-width="110px"  class="get_the_date" label="领取时间：">
                    <p>{{licenseInfo.get_the_date }}</p>
                </el-form-item>
                <el-row>
                    <el-col :span="12">
                        <el-form-item prop="way" label="领取方式：" label-width="110px">
                            <p>{{licenseInfo.get_the_way | status}}</p>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="licenseInfo.get_the_way==='mail'">
                        <el-form-item prop="way" label="邮编：" label-width="100px">
                            <p>{{licenseInfo.postcode || '--'}}</p>
                        </el-form-item>
                    </el-col>
                </el-row>

                <template v-if="licenseInfo.get_the_way==='mail'">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label-width="110px" class="consignee" label="收货人姓名：" >
                                <p style="word-break: break-all">{{licenseInfo.consignee}}</p>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label-width="100px" label="联系方式：">
                                <p>{{licenseInfo.consignee_number}}</p>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item label="收货地址：" label-width="110px"  class="inline-item-wrap" >
                        <el-row>
                            <span style="margin-right: 5px">{{licenseInfo.province_name}}</span>
                            <span style="margin-right: 5px">{{licenseInfo.city_name}}</span>
                            <span v-if="licenseInfo.county_name">{{licenseInfo.county_name}}</span>
                        </el-row>
                    </el-form-item>
                    <el-form-item label="详细地址：" class="detail_address" prop="address" label-width="110px">
                           <p>{{licenseInfo.detailed_address}}</p>
                    </el-form-item>
                </template>
            </el-form>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "getLicenseByOrg",
        data(){
            return {

            }
        },
        props:{
            licenseInfo:{
                required:true,
                type:Object
            },
            showDialog:{
                default:false,
                required:false,
            },
            dw:{
                default: "520px",
                required:false
            }
        },
        computed:{
            isShow:{
                get(){
                    return this.showDialog
                },
                set(val){
                    this.$emit('update:showDialog',val)
                }
            }
        },
        created() {

        },
        methods:{

        },
        filters:{
            status(status){
                if (!status) return '暂未填写领取方式'
                switch (status) {
                    case 'mail' : status='邮寄（到付）';break;
                    case 'invite' : status='自取';break;
                }
                return status
            }
        }
    }
</script>

<style  lang="stylus">
.showLicenseAddress
    .el-form-item
        margin-bottom 0
    .detail_address,.get_the_date,.consignee
        .el-form-item__content
            display flex
            min-height 40px
            align-items center
            line-height 20px
</style>
